import React from 'react';
import CampaignEditor from './CampaignEditor';

export default function EditCampaign(props) {
    return <CampaignEditor {...props} mode="edit"/>;
}
